import React from 'react'

import { Skeleton } from '@interco/inter-ui/components/Skeleton'

import { HeaderContainer } from '../styles'

export function HeaderSkeleton() {
  return (
    <HeaderContainer $leftIcon>
      <Skeleton width="1.5rem" height="1.5rem" style={{ borderRadius: '50%' }} />
      <Skeleton width="7.165rem" height="1.5rem" />
      <Skeleton width="0rem" />
    </HeaderContainer>
  )
}
